<app-calculator-csv-import
  (reloadEvent)="reloadDataGrid($event)"
  [produktData]="produktData"
>
</app-calculator-csv-import>
